<template>
  <div class="classify-filter-row">
    <span class="classify-filter-row__label">{{ label }}</span>
    <div class="classify-filter-row__options" role="list">
      <span
        v-for="option in options"
        :key="`${label}-${option.value}`"
        class="classify-filter-tag"
        :class="{ 'classify-filter-tag--active': modelValue === option.value }"
        role="listitem"
        tabindex="0"
        @mousedown.prevent
        @click="handleSelect(option.value)"
        @keydown.enter.prevent="handleSelect(option.value)"
        @keydown.space.prevent="handleSelect(option.value)"
      >
        {{ option.label }}
      </span>
    </div>
  </div>
</template>

<script setup>
/**
 * 分类筛选单行：左侧标题 + 右侧纯文字可点击标签
 */
defineProps({
  label: {
    type: String,
    required: true,
  },
  options: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['update:modelValue', 'change'])

/**
 * @param {string} value
 */
function handleSelect(value) {
  emit('update:modelValue', value)
  emit('change', value)
}
</script>

<style scoped src="@/features/comic/styles/ComicClassifyFilterRow.css"></style>
